<template>
  <!-- <div :style="{ 'display': step === 2 ? 'none' : 'block' }" :key="String(step)"> -->
  <div>
    <v-card-title class="justify-center mb-2">{{
      $t("create-account-title")
    }}</v-card-title>
    <v-form v-model="valid" ref="form">
      <v-row>
        <v-col cols="12" class="py-0">
          <v-text-field
            v-model="name"
            :rules="[(v) => !!v || $t('field-requied')]"
            :label="$t('personal-name')"
            :prepend-inner-icon="mdiAccountOutline"
            name="name"
            class="body-2"
            placeholder=" "
            outlined
            validate-on-blur
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" class="py-0 pr-sm-2">
          <EmailField @setFormValue="email = $event" />
        </v-col>
        <v-col cols="12" sm="6" md="6" class="py-0 pl-sm-2">
          <v-text-field
            v-model="companyName"
            :label="$t('company-name')"
            :prepend-inner-icon="mdiAccountGroup"
            name="name"
            class="body-2"
            placeholder=" "
            outlined
            validate-on-blur
            required
          />
        </v-col>
      </v-row>
      <ConfirmablePassword @setFormValue="password = $event" />
      <!-- <v-row align="center" justify="center">
        <v-btn
          @click="submit"
          :loading="$store.state.loading"
          min-width="280"
          color="indigo accent-4"
          dark
          rounded
          large
          >{{ $t("create-account-button") }}</v-btn
        > -->
      <!-- </v-row> -->
    </v-form>
    <ServerError />
    <div class="text-center mt-10">
      <span class="caption">{{ $t("have-an-account") }}</span
      >&nbsp;
      <v-btn
        small
        rounded
        outlined
        color="indigo accent-4"
        @click="$store.dispatch('authentication/toStep', 'signin')"
        >{{ $t("sign-in") }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import EmailField from "./EmailField";
import PhoneField from "./PhoneField";
import ConfirmablePassword from "./ConfirmablePassword";
import ServerError from "./ServerError";
import { mdiAccountOutline, mdiAccountGroup } from "@mdi/js";

export default {
  name: "registration",
  components: { EmailField, PhoneField, ConfirmablePassword, ServerError },
  data: () => ({
    valid: true,
    name: "",
    email: "",
    phone: "",
    password: "",
    companyName: "",
    mdiAccountGroup: mdiAccountGroup,
    mdiAccountOutline: mdiAccountOutline,
  }),
  computed: {
    accountData() {
      return {
        name: this.name,
        companyName: this.companyName,
        phone: this.phone,
      };
    },
    authProvider() {
      return {
        credentials: {
          email: this.email,
          password: this.password,
        },
      };
    },
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return null;
      this.$store.dispatch("account/create", {
        accountData: this.accountData,
        authProvider: this.authProvider,
      });
    },
  },
};
</script>
